import React from "react";
import MaterialTable from "material-table";
import tableicons from "../tableicons";
import {inventarioResources, revisarResources, tagResources, ValidacionConteoResources} from "../endpoints";
import {Card} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import DialogEditarCantidadConteo from "./DialogEditarCantidadConteo";
import CheckIcon from '@material-ui/icons/Check';
import {withRouter} from "react-router";
import SnackbarAlert from "./SnackbarAlert";
import DialogEliminarConteo from "./DialogEliminarConteo";
import DialogRevisarConteo from "./DialogRevisarConteo";
import BlockIcon from "@material-ui/icons/Block";
import SearchIcon from "@material-ui/icons/Search";
import RestoreFromTrashIcon from "@material-ui/icons/RestoreFromTrash";
import DialogRestaurarConteoEliminado from "./DialogRestaurarConteoEliminado";
import useToken from "../useToken";

class TablaTagSinFactor extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            editar_cantidad: false,
            eliminar_conteo:false,
            datos:[],
            cargando: true,
            registros: 0,
            cantidadFin:0,
            cantidadCapt:0,
            valor:0,
            selectedRow:null,
            datos_conteo: "",
            openSnack:false,
            severity: null,
            message:null,
            motivos:[],
            motivo: "",
            revisar:false,
            desrevisar:false,
            restaurar:false,
            title_table:null,
            mandatorio: null,
        }
    }

    consultarTag = () =>{
        this.setState({cargando: true})
        const tag = this.props.tag;
        let tipo = this.props.tipo;
        let origen = this.props.origen;
        this.setState({openSnack:false, severity: null, message:null})
        if (origen === 'conteo_significativos'){
            ValidacionConteoResources.getConteosSignificativos().then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(data => {
                if (data.status_code === 200) {
                    this.setState({datos: data.consulta, cargando: false})
                    if (data.consulta.length > 0) {
                        this.props.handleLoading("con datos");
                    } else {
                        this.props.handleLoading("sin datos");
                    }
                } else if (data.status_code === 401) {
                    this.setState({openSnack: true, severity: data.severity, message: data.message})
                } else {
                    throw new Error('Something went wrong ...');
                }
            }).catch(error => {
                console.error(error);
                this.props.handleLoading();
            });
        }
        else {
            tagResources.consultarTag(tag, tipo).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(data => {
                if (data.status_code === 200) {
                    this.setState({datos: data.consulta, cargando: false})
                    if (data.consulta.length > 0) {
                        this.props.handleLoading("con datos");
                    } else {
                        this.props.handleLoading("sin datos");
                    }
                } else if (data.status_code === 401) {
                    this.setState({openSnack: true, severity: data.severity, message: data.message})
                } else {
                    throw new Error('Something went wrong ...');
                }

            }).catch(error => {
                console.error(error);
                this.props.handleLoading();
            });
        }
    }

    getIdTag = () =>{
        const tag = this.props.tag;
        tagResources.getIdTag(tag).then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(data => {
            if(data.id){
                this.setState({title_table: "Detalle de tag " + data.id + " sin factor"})
            }
            else{
                this.setState({title_table: "Detalle de tag sin factor"})
            }
        }).catch(error=> {
            console.error(error);
        });
    }

    obtenerTotales =() =>{
        const tag = this.props.tag;
        let tipo = this.props.tipo;

        if (this.props.origen !== 'conteo_significativos') {
            tagResources.totalesTag(tag, tipo).then(async response => {
                if (response.ok) {
                    return await response.json();
                } else {
                    throw new Error('Something went wrong ...');
                }
            }).then(data => {
                this.setState({
                    registros: new Intl.NumberFormat("de-DE").format(data.registros),
                    cantidadFin: new Intl.NumberFormat("de-DE").format(data.sum_cantumb),
                    cantidadCapt: new Intl.NumberFormat("de-DE").format(data.sum_cant),
                    valor: new Intl.NumberFormat("de-DE").format(data.sum_importe)
                })
            }).catch(error => {
                console.error(error);
            });
        }
        if (this.props.origen === "eliminados" ) {
            this.consultar_eliminados_tag()
        }
        else if (this.props.origen === 'conteo_significativos'){
            this.consultarTag()
        }
        else {
            this.consultarTag()
            this.getIdTag()
        }
    }

    enviar_datos_conteo = (row) =>{
        this.setState({editar_cantidad:true, datos_conteo:row})
    }
s
    handleClose = () =>{
        this.setState({editar_cantidad:false, eliminar_conteo:false, revisar:false,desrevisar:false,restaurar:false})
    }

    para_eliminar = (row) =>{
        this.setState({eliminar_conteo:true, datos_conteo:row})
    }

    consultar_eliminados_tag =() =>{
        this.setState({openSnack:false, severity: null, message:null})
        const tag = this.props.tag;
        inventarioResources.getEliminadosTag(tag).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(data => {
            if(data.status_code === 200){
                this.setState({datos: data.eliminados, cargando:false})
                if(data.length > 0){
                    this.props.handleLoading("con datos");
                }
                else{
                    this.props.handleLoading("sin datos");
                }
            }
            else if (data.status_code === 401){
                this.setState({openSnack:true, severity:data.severity, message:data.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.error(error);
            this.props.handleLoading();
        });
    }

    verDetalles = (rowData) =>{
        if(this.props.tipo === "agrupado"){
            this.props.history.push("/detalle_conteo/" + this.props.tipo +"/" + rowData.codigo +"/" + this.props.tag + "/" + rowData.id_codigo_tipo)
        }
        else{
            if(this.props.origen === "conteo_significativos"){
                this.props.history.push("/detalle_conteo/" + this.props.tipo +"/" + rowData.id +"/" + rowData.tag + "/" + 0)
            }
            else{
                this.props.history.push("/detalle_conteo/" + this.props.tipo +"/" + rowData.id + "/" + this.props.tag + "/" + 0)
            }
        }
    }

    refrescar = (estado,severity) =>{
        this.setState({editar_cantidad:false, eliminar_conteo: false, revisar:false, desrevisar:false,
            restaurar:false, openSnack:false, severity: null, message:null}, ()=>{
            if(severity === "success"){
                if (this.props.origen !== 'conteo_significativos'){
                    this.props.getRevision()
                }
                this.obtenerTotales()
            }
            // pequeño delay para reabrir el snack
            setTimeout(() => {
                this.setState({
                    openSnack: true,
                    severity: severity,
                    message: estado,
                });
            }, 50);
        })
    }

    paraRestaurar = (row) =>{
        this.setState({restaurar:true, datos_conteo:row})
    }

    componentDidMount() {
        this.obtenerTotales()
        if (this.props.mandatorio === 'mandatorio/espejo'){
            this.setState({origen_ajuste:'mandatorio/espejo'})
        }
        else{
            this.setState({origen_ajuste:'detalle_tag'})
        }
        let datos_inv = useToken.getDatos()
        this.setState({cliente:datos_inv.app})
    }

    revisarConteo = (row) =>{
        if(this.props.tipo === "desagrupado" || this.props.origen === 'conteo_significativos'){
            revisarResources.revisarConteo(row.id,this.state.origen_ajuste).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.refrescar("Ha ocurrido un error inesperado","error")
                console.log(error)
            });
        }
        else{
            revisarResources.revisarConteoAgrupado(this.props.tag,row.codigo,row.id_codigo_tipo,this.state.origen_ajuste).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.refrescar("Ha ocurrido un error inesperado","error")
                console.log(error)
            });
        }
    }

    desrevisarConteo = (row) =>{
        if(this.props.tipo === "desagrupado" || this.props.origen === 'conteo_significativos'){
            revisarResources.desrevisarConteo(row.id).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.refrescar("Ha ocurrido un error inesperado","error")
                console.log(error)
            });
        }
        else{
            revisarResources.desrevisarContepAgrupado(this.props.tag,row.codigo,row.id_codigo_tipo).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.message){
                    this.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.refrescar("Ha ocurrido un error inesperado","error")
                console.log(error)
            });
        }
    }

    render() {
        return (
            <div>
                { this.props.origen !== 'conteo_significativos' && <Card style={{background:'#dbe9fc'}} >
                    <CardContent>
                        <Grid container spacing={4} alignItems={'center'} justifyContent={"center"}>
                            <Grid item>
                                <b>Total Registros: </b>{this.state.registros}
                            </Grid>
                            <Grid item>
                                <b>Total Cant. Fin: </b>{this.state.cantidadFin}
                            </Grid>
                            <Grid item>
                                <b>Total Valor: </b>{this.state.valor}
                            </Grid>
                            <Grid item>
                                <b>Total Cant. Capt.: </b>{this.state.cantidadCapt}
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>}
                <br/>
                <MaterialTable
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar',
                            nRowsSelected: "{0} registro(s) seleccionado(s)"
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        },
                        pagination:{
                            firstAriaLabel: 0,
                        },
                        header: {
                            actions: 'Acciones',
                            sizeActions:"large"
                        },
                    }}
                    options={{
                        pageSize: 50,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense",
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                        }),
                    }}
                    onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                    isLoading={this.state.cargando}
                    icons={tableicons}
                    title= {this.state.title_table}
                    data={this.state.datos}
                    columns={[
                        { title: 'Tag', field: 'tag', hidden: this.props.origen !== 'conteo_significativos',
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: 'Material', field: 'articulo',
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: 'Cód. escan.', field: 'codigo',
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: 'Lote', field: 'lote',
                            hidden: this.state.cliente !== 'walmart_flejes',
                            cellStyle: {
                                width: 100,
                                maxWidth: 100,
                            },
                            headerStyle: {
                                width: 100,
                                maxWidth: 100
                            }
                        },
                        { title: 'Descripción material', field: 'descripcion',
                            cellStyle: {
                                width: 700,
                                maxWidth: 700,
                            },
                            headerStyle: {
                                width: 700,
                                maxWidth: 700
                            }
                        },
                        { title: 'Valor', field: 'importe',
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.importe)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.importe).indexOf(term) !== -1),
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: 'Cant. Capt.', field: 'cantidad',
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.cantidad)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.cantidad).indexOf(term) !== -1),
                            cellStyle: {
                                width: 200,
                                maxWidth: 200,
                            },
                            headerStyle: {
                                width: 200,
                                maxWidth: 200
                            }
                        },
                        { title: 'Nivel', field: 'nivel',
                            hidden: this.props.tipo !== "desagrupado",
                            cellStyle: {
                                width: 100,
                                maxWidth: 100,
                            },
                            headerStyle: {
                                width: 100,
                                maxWidth: 100
                            }
                        },

                        { title: 'Descarga', field: 'id_archivo',
                            hidden: this.props.tipo !== "desagrupado",
                            cellStyle: {
                                width: 100,
                                maxWidth: 100,
                            },
                            headerStyle: {
                                width: 100,
                                maxWidth: 100
                            }
                        },
                        { title: 'Modificado', field: 'modificado',
                            hidden: this.props.tipo === "consolidado",
                            render: rowData => (rowData.modificado ? <CheckIcon/> : null),
                            cellStyle: {
                                width: 100,
                                maxWidth: 100,
                            },
                            headerStyle: {
                                width: 100,
                                maxWidth: 100
                            }
                        },
                        { title: 'Revisado', field: 'revisado',
                            hidden: this.props.tipo === "consolidado",
                            render: rowData => (rowData.revisado ? <CheckIcon/> : null),
                            cellStyle: {
                                width: 100,
                                maxWidth: 100,
                            },
                            headerStyle: {
                                width: 100,
                                maxWidth: 100
                            }
                        }
                    ]}
                    actions={[
                        {
                            icon:  () => <SearchIcon style={{fontSize:27, margin:5}}/>,
                            tooltip: 'Ver detalle',
                            position: 'row',
                            onClick: (event, rowData) => this.verDetalles(rowData),
                            hidden: this.props.tipo === "consolidado" || this.props.origen === "eliminados"
                        },
                        rowData => ({
                                icon:  () => <CheckIcon style={{fontSize:27, margin:5}}/>,
                                tooltip: 'Marcar como revisado',
                                position: 'row',
                                onClick: (event, rowData) => this.revisarConteo(rowData),
                                hidden: rowData.revisado === true || this.props.origen === "eliminados" || this.props.tipo === "consolidado"
                        }),
                        rowData => ({
                            icon:  () => <BlockIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Marcar como no revisado',
                            position: 'row',
                            onClick: (event, rowData) => this.desrevisarConteo(rowData),
                            hidden: rowData.revisado !== true || this.props.origen === "eliminados" ||this.props.tipo === "consolidado"
                        }),
                        {
                            icon:  () => <CreateIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Editar conteo',
                            position: 'row',
                            onClick: (event, rowData) => this.enviar_datos_conteo(rowData),
                            hidden: this.props.tipo === "consolidado" || this.props.origen === "eliminados" || this.props.origen === 'conteo_significativos'
                        },
                        {
                            icon:  () => <DeleteIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Eliminar conteo',
                            position: 'row',
                            onClick: (event, rowData) => this.para_eliminar(rowData),
                            hidden: this.props.tipo === "consolidado" || this.props.origen === "eliminados" || this.props.origen === 'conteo_significativos'
                        },
                        {
                            icon:  () =><RestoreFromTrashIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Reestablecer conteo eliminado',
                            position: 'row',
                            onClick: (event, rowData) => this.paraRestaurar(rowData),
                            hidden: this.props.origen !== "eliminados"
                        },
                    ]}
                />
                {this.state.editar_cantidad && <DialogEditarCantidadConteo origen={this.state.origen_ajuste} tag={this.props.tag} refrescar={this.refrescar} tipo={this.props.tipo} handleClose={this.handleClose} conteo={this.state.datos_conteo}/>}

                {this.state.eliminar_conteo && <DialogEliminarConteo refrescar={this.refrescar} tag={this.props.tag} tipo={this.props.tipo} handleClose={this.handleClose} conteo={this.state.datos_conteo}/>}

                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}

                {this.state.revisar && <DialogRevisarConteo origen={this.state.origen_ajuste} revisar={true} tag={this.props.tag} tipo={this.props.tipo} handleClose={this.handleClose} conteo={this.state.datos_conteo} refrescar={this.refrescar}/>}

                {this.state.desrevisar && <DialogRevisarConteo origen={this.state.origen_ajuste} revisar={false} tag={this.props.tag} tipo={this.props.tipo} handleClose={this.handleClose} conteo={this.state.datos_conteo} refrescar={this.refrescar}/>}

                {this.state.restaurar ? <DialogRestaurarConteoEliminado title={"Restaurar conteo eliminado"} recuperar={"conteo"}  conteo={this.state.datos_conteo} refrescar={this.refrescar}  handleClose={this.handleClose}/>: null}
            </div>
        )
    }
}

export default withRouter(TablaTagSinFactor)